import React, {useEffect, useState} from 'react'
import {
  BlogContainer,
  BlogContent,
  BlogContentDescription,
  BlogIcon,
  BlogImg,
  BlogMainContainer,
  BlogSectionPadding,
  BlogShare,
  BlogShareTitle,
  BlogSmallSocialMedia,
  BlogSubscribe,
  BlogSubtitle,
  BlogTag,
  BlogTags,
  BlogThumbnail,
  BlogTitle
} from './style'
import {Skeleton} from '@mui/material';
import {useNavigate, useParams} from 'react-router';
import moment from 'moment';
import SubscribeEmail from '../../components/blog/subscribe/SubscribeEmail'
import './style.css'
import BackButton from "../../components/BackButton";
import URLUtils from "../../util/URLUtils";
import {getBlogPost, getRelatedBlogs} from "../../requests/hubspot-requests";
import RelatedBlogs from "../../components/blog/relatedBlogs/RelatedBlogs";
import DOMPurify from 'dompurify';

const BlogDetails = () => {
    const [loading, setLoading] = useState(false);
    const [singlePost, setSinglePost] = useState(null);
    const history = useNavigate();
    const [email, setEmail] = useState('');
    const params = useParams();
    const [contentGroupId, setContentGroupId] = useState(null);
    const [relatedBlogs, setRelatedBlogs] = useState([]);
    let ctaRegex = /{{cta\([^)]*\)}}/g;


    const LIMIT = 5
    const OFFSET = 0

    useEffect(() => {
        if (params?.postId) {
            setLoading(true);
            getBlogPost(params?.postId).then(response => {
                // Parse the response properly
                const body = response.body || JSON.parse(response.text || '{}');

                setContentGroupId(body?.contentGroupId);
                setSinglePost(body);
                if (body?.name && body.name.length && !params.title) {
                    const urlString = URLUtils.formatEncodePath(body?.name);
                    history(`/blog/${params?.postId}/${urlString}`, { replace: true });
                }
            }).catch(() => {
                history('/blogs');
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [params, history]);

    useEffect(() => {
        if (contentGroupId) {
            getRelatedBlogs(contentGroupId, LIMIT, OFFSET).then(response => {
                // Parse the response properly
                const responseData = response.body || JSON.parse(response.text || '{}');
                setRelatedBlogs(responseData?.results || []);
            }).catch(error => {
                console.log('Error fetching related blogs:', error);
                setRelatedBlogs([]);
            });
        }
    }, [contentGroupId]);

    return (
        <>
            <BlogSectionPadding>
                <BlogContainer>
                    <BlogMainContainer>
                        <BackButton onClick={() => history("/blogs")}>
                            Back to blogs
                        </BackButton>
                        {loading ? <Skeleton width='40%' height={40} /> : <BlogTitle>{singlePost?.name}</BlogTitle>}
                        {loading ? <Skeleton width="30%" /> : <BlogSubtitle>{moment(singlePost?.publishDate).format('MMMM Do YYYY')}</BlogSubtitle>}
                        <BlogThumbnail>
                            <BlogImg src={singlePost?.featuredImage} errorImg='/app-images/not-found-image/place_holder_image.png' alt={singlePost?.name || 'Blog Title'} />
                        </BlogThumbnail>
                        <BlogContent>
                            <BlogShare>
                                <BlogShareTitle>Share</BlogShareTitle>
                                <a href="https://www.facebook.com/">
                                    <BlogIcon src="https://static.secur.space/icons/facebook.png" alt="Icon" />
                                </a>
                                <a href="https://www.twitter.com/">
                                    <BlogIcon src="https://static.secur.space/icons/twitter.png" alt="Icon" />
                                </a>
                                <a href="https://www.linkedin.com/">
                                    <BlogIcon src="https://static.secur.space/icons/linkedin.png" alt="Icon" />
                                </a>
                            </BlogShare>
                            <BlogContentDescription>
                                {loading ? <>
                                    {[...Array(27).keys()].map((_, index) => {
                                        return index % 4 === 0 ? <br key={index} ></br> : <Skeleton key={index} variant='text' />
                                    })}
                                </> : <div
                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(singlePost?.postBody.replace(ctaRegex, ""), { ADD_TAGS: ['iframe'] }) }}
                                    className='ss-blog-content'
                                />}
                                <BlogSmallSocialMedia>
                                    <BlogShareTitle>Share: </BlogShareTitle>
                                    <a href="https://www.facebook.com/">
                                        <BlogIcon src="https://static.secur.space/icons/facebook.png" alt="Icon" />
                                    </a>
                                    <a href="https://www.twitter.com/">
                                        <BlogIcon src="https://static.secur.space/icons/twitter.png" alt="Icon" />
                                    </a>
                                    <a href="https://www.linkedin.com/">
                                        <BlogIcon src="https://static.secur.space/icons/linkedin.png" alt="Icon" />
                                    </a>
                                </BlogSmallSocialMedia>
                                <BlogTags>
                                    <BlogTag>Secure Truck Parking</BlogTag>
                                </BlogTags>
                            </BlogContentDescription>
                            <BlogSubscribe>
                                <SubscribeEmail email={email} setEmail={setEmail} />
                                <RelatedBlogs relatedBlogs={relatedBlogs} />
                            </BlogSubscribe>
                        </BlogContent>
                    </BlogMainContainer>
                </BlogContainer>
            </BlogSectionPadding>
        </>
    )
}

export default BlogDetails;
